import {
  BattlePokemonData,
  PokemonType as PT,
  SkillData,
  SkillStatusEffect,
  StatusEffect,
  StatusEffectInstance,
} from "types/battle-engine/battle";
import { getTypeEffectiveness } from "./type-effectiveness";
import { getDamageMultiplier } from "game/duel-engine/utils/stat-scaling";

interface CalculateDamageParams {
  inbound: {
    damage: number;
    type: PT;
    attackerStatusEffects: (SkillStatusEffect | StatusEffectInstance)[];
    attackerEffectiveAP?: number;
  };
  defender: {
    pokemon: BattlePokemonData;
    defenderStatusEffects: (SkillStatusEffect | StatusEffectInstance)[];
    defenderDodgeChance?: number;
  };
}

export const calculateDamage = ({
  inbound,
  defender,
}: CalculateDamageParams) => {
  // Check for dodge
  if (defender.defenderDodgeChance) {
    const roll = Math.random();
    if (roll < defender.defenderDodgeChance) {
      return 0;
    }
  }

  const [defenderType1, defenderType2] = defender.pokemon.pokemon_types;

  let typeEffectivenessFactor = 1;
  let attackBoostFactor = 1;
  let defenseBoostFactor = 1;

  if (defenderType1) {
    typeEffectivenessFactor *= getTypeEffectiveness(
      inbound.type,
      defenderType1,
    );
  }

  if (defenderType2) {
    typeEffectivenessFactor *= getTypeEffectiveness(
      inbound.type,
      defenderType2,
    );
  }

  // Apply damage boost from attacker status effects, if any
  const attackerAttackUp = inbound.attackerStatusEffects.find(
    (statusEffect) => statusEffect.status === StatusEffect.ATTACK_UP,
  );

  if (attackerAttackUp) {
    attackBoostFactor *= 1 + attackerAttackUp.intensity * 0.1;
  }

  // Apply defense boost from attacker status effects, if any
  const attackerDefenseUp = inbound.attackerStatusEffects.find(
    (statusEffect) => statusEffect.status === StatusEffect.DEFENSE_UP,
  );

  if (attackerDefenseUp) {
    defenseBoostFactor *= 1 - attackerDefenseUp.intensity * 0.1;
  }

  // Apply AP scaling
  let apMultiplier = 1;
  if (inbound.attackerEffectiveAP !== undefined) {
    apMultiplier = getDamageMultiplier(inbound.attackerEffectiveAP);
  }

  return (
    inbound.damage *
    typeEffectivenessFactor *
    attackBoostFactor *
    defenseBoostFactor *
    apMultiplier
  );
};
